<template>
  <div class="main-category mb-4">
    <div class="d-flex align-items-center">
      <font-awesome-icon :icon="category.icon" class="badge main" />
      <p class="title">{{ category.title }}</p>
    </div>
    <div class="d-flex align-items-center">
      <font-awesome-icon @click="handleEditing" icon="fa-solid fa-pen" class="mr-3 badge" />
      <font-awesome-icon @click="handleDelete" icon="fa-solid fa-trash-can" class="ml-3 badge delete" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    category: {
      type: Object,
      required: true
    }
  },
  methods: {
    handleDelete(e) {
      e.stopPropagation()
      this.$emit('delete-category', this.category)
    },
    handleEditing(e) {
      e.stopPropagation()
      this.$emit('edit-category', this.category)
    }
  }
}
</script>

<style lang="scss" scoped>
.main-category {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #cce9d8;
  border-radius: 8px;
  border: 1px solid #b2bec3;
  padding: 24px;
  font-size: 20px;
  box-shadow: 0px 2px 8px rgba(99, 110, 114, 0.2);
}

.title {
  font-weight: 700;
  font-size: 20px;
  margin: 0;
}

.badge {
  cursor: pointer;
  font-size: 16px;
  padding: 0;
}

.badge.delete {
  color: #ba3b46;
}
.badge.main {
  display: none;
}

@media screen and (min-width: 1200px) {
  .title {
    font-size: 24px;
  }
  .badge {
    font-size: 24px;
  }
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .title {
    font-size: 16px;
  }
  .badge {
    font-size: 16px;
  }
}

@media screen and (min-width: 391px) {
  .badge.main {
    display: block;
    color: #00903c;
    font-size: 40px;
    margin-right: 24px;
  }
}
</style>
